import { GlobalAxios } from "../axios/axios-config";
import { IProcedureSpecialty } from "../models/procedure-specialty";

const PROCEDURE_SPECIALTY_ROUTE = process.env.REACT_APP_EXTERNAL + "/api/v1/ProcedureSpecialty";

export const procedureSpecialtyList = (params?: any) => {
  return GlobalAxios.get<IProcedureSpecialty[]>(PROCEDURE_SPECIALTY_ROUTE, {
    params,
  });
};
